import { useRef } from 'react'

let globalId = 0

/**
 *
 */
export function useId (prefix = 'id'): string {
    const idRef = useRef(null)
    if (idRef.current === null) {
        globalId += 1
        idRef.current = `${prefix}-${globalId}`
    }
    return idRef.current
}
